import { useQuery } from '@tanstack/react-query';
import { wbsApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const REFERENCE_STALE_TIME = 5 * 60_000;

export function useCostCodes() {
  return useQuery({
    queryKey: queryKeys.costCodes.list(),
    queryFn: ({ signal }) => wbsApiClient.getCostCodes(toCancelToken(signal)),
    staleTime: REFERENCE_STALE_TIME,
    meta: {
      suppressErrorToast: true,
      errorContext: 'cost codes',
    },
  });
}
